const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    "text-align": "center",
    transform: "translate(-50%, -50%)",
  },
  h2: {
    color: "black",
  },
};

const buttonStyle = {
  backgroundColor: "#0059d6" /* Blue */,
  border: "none",
  color: "white",
  padding: "15px 32px",
  "text-align": "center",
  "text-decoration": "none",
  display: "inline-block",
  borderRadius: "4px",
  width: "80%",
};

const loginWrapper = {
  backgroundColor: "#001531" /* Navy Blue */,
  borderRadius: "5px",
  display: "flex",
  "align-items": "center",
  justifyContent: "center",
  height: "100vh",
  width: "100%",
};

const formBox = {
  width: "380px",
  height: "450px",
  backgroundColor: "#f2f2f2",
  padding: "20px",
  display: "flex",
  "flex-direction": "column",
  justifyContent: "flex-start",
  "text-align": "center",
  borderRadius: "2%",
};

import { Auth, Hub } from "aws-amplify";

import { Amplify } from "aws-amplify";
import { ThemeProvider } from "emotion-theming";
import { defaultTheme } from "@deliverr/ui";
import { getAmplifyConfig } from "../utils/AuthUtils";
import { useNavigate } from "react-router";
import { useState } from "react";

Amplify.configure(getAmplifyConfig());

export function Login() {
  const [error, setError] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);

  const navigate = useNavigate();

  const initializeHubListener = () => {
    Hub.listen("auth", async ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          {
            console.info("Login:Hub: User signed in");
            const currentUser = await Auth.currentAuthenticatedUser();
            setUser(currentUser);

            const idToken = currentUser.signInUserSession.idToken.jwtToken;
            localStorage.setItem("user-token-ops", idToken);
            navigate("/LostUnits/List");
          }
          break;
        case "signOut":
          console.info("Login:Hub: User signed out");
          localStorage.clear();
          setUser(null);
          break;
        case "customOAuthState":
          console.error("Login:Hub: Custom OAuth state:", data);
          setError("Received unexpected custom OAuth state event");
          break;
        case "signIn_failure":
          console.error("Login:Hub: Sign in failed", data);
          setError(data);
          break;
        default:
          // Nothing to do. Also not logging the event
          break;
      }
    });
  };

  const handleLogin = async (event: any) => {
    event.preventDefault();
    try {
      setError(null); // Clear error state

      // We are not using `Auth.federatedSignIn({ customProvider: "Auth0Google" })`. The reason is
      // that we want the full host UI experience for the internal user, including the ability to sign in
      // with username/password (it that was previously enabled) for the internal user.
      const result = Auth.federatedSignIn();

      // For federated sign in, the result of Auth.federatedSignIn is not useful. Instead we use Hub listener to
      // get the user once sign in is completed
      console.info("Login.handleLogin: Auth.federatedSignIn result", result);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message || "Login.handleLogin: Error signing in");
        console.error(err.message || "Login.handleLogin: Error signing in");
      } else {
        setError("Login.handleLogin: Error signing in");
        console.error("Login.handleLogin: Error signing in");
      }
    }
  };

  // Initialize Hub listener
  initializeHubListener();

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="login-wrapper" style={loginWrapper}>
        <form onSubmit={handleLogin} style={formBox}>
          <div>
            <div>
              <div title="Flexport" id="custom-prompt-logo"></div>
              <img
                id="flexport-logo"
                src="https://static.deliverr.com/flexport-logo.png"
                alt="Flexport"
              ></img>
              <div>
                <h2 style={customStyles.h2}>Welcome to Ops Portal</h2>
                Log in to Continue
              </div>
            </div>
            <br></br>
            <button
              style={buttonStyle}
              type="submit"
              className="btn-secondary btn-block"
            >
              Sign in with your Flexport Auth0Google
            </button>
          </div>
          <br></br>
          <div> {error} </div>
        </form>
      </div>
    </ThemeProvider>
  );
}
